import { useEffect, useMemo, useState, type ReactNode } from 'react'

import {
  applyTheme,
  readThemePreference,
  resolveTheme,
  systemPrefersDark,
  watchSystemTheme,
  writeThemePreference,
  type ThemePreference,
} from './theme'
import { ThemeContext, type ThemeContextValue } from './use-theme'

/** Light, dark or system (the default, so the first load follows the OS). Persisted in `tr-theme`. */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<ThemePreference>(readThemePreference)
  const [prefersDark, setPrefersDark] = useState(systemPrefersDark)
  const resolvedTheme = resolveTheme(theme, prefersDark)

  useEffect(() => watchSystemTheme(setPrefersDark), [])
  useEffect(() => applyTheme(resolvedTheme), [resolvedTheme])

  const value = useMemo<ThemeContextValue>(
    () => ({
      theme,
      resolvedTheme,
      setTheme(next) {
        writeThemePreference(next)
        setThemeState(next)
      },
    }),
    [theme, resolvedTheme],
  )
  return <ThemeContext value={value}>{children}</ThemeContext>
}
